import { Box, Typography } from "@mui/material";
import { Flex, colors } from "@zfp-akademie-a-s/zfp-design";
import { Radius, Spacing } from "Infrastructure/Themes/Themes";
import type { ReactNode } from "react";

type GoalCardDetail = { label: string; value: string };

type Props = {
  title: string;
  details?: GoalCardDetail[];
  children: ReactNode;
};

/** Frames goal-bound content the same way in the questionnaire steps and on the evaluation page. */
export const QuestionnaireGoalCard = ({ title, details = [], children }: Props) => (
  <Box border="1px solid" borderColor="divider" borderRadius={Radius.L} overflow="hidden" sx={{ breakInside: "avoid" }}>
    <Flex
      justifyContent="space-between"
      alignItems="center"
      flexWrap="wrap"
      columnGap={Spacing.XL}
      rowGap={Spacing.S}
      px={Spacing.XL}
      py={Spacing.L}
      bgcolor={colors.backgroundSecondary}
      sx={{ breakAfter: "avoid", breakInside: "avoid" }}
    >
      <Typography variant="body1" fontWeight={600}>
        {title}
      </Typography>
      {details.length > 0 && (
        <Flex columnGap={Spacing.XL} flexWrap="wrap">
          {details.map((detail) => (
            <Typography key={detail.label} variant="body2" color="text.secondary" noWrap>
              {detail.label}{" "}
              <Box component="span" color="text.primary" fontWeight={500}>
                {detail.value}
              </Box>
            </Typography>
          ))}
        </Flex>
      )}
    </Flex>
    <Box p={Spacing.XL}>{children}</Box>
  </Box>
);
